import { computed } from 'vue'

declare interface formProps {
	inline?: boolean
	theme: string
	error?: string
	type?: string
	size: string
	prefix?: string
	disabled?: boolean
}

export function useFieldClasses(props: formProps) {
	const inputGroupClasses = computed(() => ({
		'sm:flex sm:justify-between sm:gap-10': props.inline
	}))

	const wrapperClasses = computed(() => ({
		'flex overflow-hidden relative grow rounded-md shadow-sm ring-1 ring-inset ring-gray-300 focus-within:ring-2 focus-within:ring-inset':
			true,
		'focus-within:ring-mabey-950': props.theme == 'primary',
		'focus-within:ring-cyan-400': props.theme == 'secondary',
		'focus-within:ring-green-500': props.theme == 'success',
		'focus-within:ring-mabey-600': props.theme == 'info',
		'focus-within:ring-yellow-500': props.theme == 'warning',
		'focus-within:ring-red-600': props.theme == 'danger',
		'ring-red-600': props.error,
		'text-md': props.size === 'large',
		'text-xs': props.size === 'small',
		'bg-gray-100': props.disabled,
		'bg-white': !props.disabled
	}))

	const fieldClasses = computed(() => ({
		'block flex-1 border-0 bg-transparent placeholder:text-gray-400 focus:ring-0 sm:leading-6 focus:outline-none':
			true,
		'py-2 px-3.5': props.size === 'large',
		'py-1.5 px-2.5 sm:text-sm': props.size == 'medium',
		'py-1 px-2.5 text-xs': props.size === 'small',
		'pl-1': props.prefix,
		'text-gray-500 opacity-40 cursor-not-allowed': props.disabled,
		'text-gray-900': !props.disabled
	}))

	const selectClasses = computed(() => ({
		'block flex-1 border-0 bg-transparent text-gray-900 focus:ring-0 sm:leading-6 focus:outline-none':
			true,
		'py-1.5 px-2.5 h-10': props.size === 'large',
		'py-1.5 px-2.5 h-9 sm:text-sm': props.size == 'medium',
		'py-1 px-1.5 h-8 text-xs': props.size === 'small',
		'opacity-40 cursor-not-allowed': props.disabled
	}))

	const checkboxClasses = computed(() => ({
		'border-gray-300': true,
		rounded: props.type == 'checkbox',
		round: props.type == 'radio',
		'focus-within:ring-mabey-950 text-mabey-950': !props.error && props.theme == 'primary',
		'focus-within:ring-cyan-400 text-cyan-950': !props.error && props.theme == 'secondary',
		'focus-within:ring-green-500 text-green-950': !props.error && props.theme == 'success',
		'focus-within:ring-mabey-600 text-mabey-600': !props.error && props.theme == 'info',
		'focus-within:ring-yellow-500 text-yellow-500': !props.error && props.theme == 'warning',
		'focus-within:ring-red-600 text-red-600': !props.error && props.theme == 'danger',
		'h-5 w-5': props.size === 'large',
		'h-4 w-4': props.size == 'medium',
		'h-3 w-3': props.size === 'small',
		'ring-2 ring-offset-1 ring-red-600': props.error,
		'opacity-40 cursor-not-allowed': props.disabled
	}))

	return {
		inputGroupClasses,
		wrapperClasses,
		fieldClasses,
		selectClasses,
		checkboxClasses
	}
}
